import {
  GetHealthyPerkResponseDto,
  ModifiedHealthyPerkData,
} from "types/healthyPerk";
import { Loyalty } from "types/loyalty";

const initialData: ModifiedHealthyPerkData = {
  mon: [],
  tue: [],
  wed: [],
  thu: [],
  fri: [],
  sat: [],
  sun: [],
};

export const getModifiedData = (
  data: GetHealthyPerkResponseDto["data"],
  tiers: Loyalty[],
): ModifiedHealthyPerkData => {
  if (!data || !tiers) return initialData;

  const modifiedData = Object.entries(data).reduce((acc, [day, perks]) => {
    acc[day] = perks.map(perk => {
      return {
        ...perk,
        tiersData: perk.tiers
          .map(tierId => {
            const tier = tiers.find(t => t.id === tierId);
            return tier ? { ...tier, id: tierId } : null;
          })
          .filter(Boolean),
      };
    });
    return acc;
  }, initialData);

  return modifiedData;
};
